<template>
  <div>
    <div class="d-flex toolbar justify-content-between mb-4">
      <h4 class="text-color-4">ตั้งค่าระบบรับออเดอร์</h4>
    </div>
    <div v-if="loading">
      <Spinner size="sm" />
    </div>
    <div v-else
         id="checkout-form">

      <div class="rounded">
        <h5 class="mb-4 text-primary">รายละเอียดพร้อมเพย์</h5>

        <PromptpayId :id="'promptpay-id'"
                     :label="'เบอร์โทร/ บัตรประชาชน / เลขที่นิติบุคคล'"
                     v-model="qrForm.ppId" />

        <TextBox type="text"
                 :id="'promptpayName'"
                 v-model="qrForm.ppName"
                 :placeholder="'ชื่อ'"
                 :label="'ชื่อ'"
                 wrapper_class="mb-0"
                 input_wrapper_class="mb-0 pb-1" />
      </div>

      <div class="mt-5">
        <h5 class="mb-4 text-primary">ธนาคาร</h5>

        <BankSelectDropdown @input="(name) => { qrForm.bankName = name }"
                            :value="qrForm.bankName"
                            wrapper_class="mb-4" />

        <TextBox type="text"
                 :id="'bankAccNo'"
                 v-model="qrForm.bankAccNo"
                 :placeholder="'เลขบัญชี'"
                 :label="'เลขบัญชี'"
                 wrapper_class="mb-4"
                 input_wrapper_class="mb-0 pb-1" />

        <TextBox type="text"
                 :id="'bankAccName'"
                 v-model="qrForm.bankAccName"
                 :placeholder="'ชื่อบัญชี'"
                 :label="'ชื่อบัญชี'"
                 wrapper_class="mb-4"
                 input_wrapper_class="mb-0 pb-1" />
      </div>

      <hr />

      <Button type="button"
              variant="primary"
              custom_class="btn-block mr-4"
              @click="handleFormSubmit()"
              :loading="formLoading">{{ $t("general.update") }}</Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/core/Button";
import NumberField from "@/components/core/NumberField";
import Card from "@/components/core/Card";
import TextBox from "@/components/core/TextBox";
import PromptpayId from "@/components/derived/PromptpayId";
import SmartAddress from "@/components/derived/SmartAddress";
import Spinner from "@/components/core/Spinner";
import BankSelectDropdown from "@/components/derived/BankSelectDropdown";

export default {
  name: "SellerSettingsQr",
  components: {
    Card,
    TextBox,
    Spinner,
    Button,
    SmartAddress,
    NumberField,
    PromptpayId,
    BankSelectDropdown,
  },

  data() {
    return {
      loading: false,
      formLoading: false,
      qrForm: {
        ppId: null,
        ppName: null,
        bankName: null,
        bankAccNo: null,
        bankAccName: null
      },
    };
  },

  async created() {
    await this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      const { status, data } = await this.$store.dispatch("settings/fetchSetting", { type: "payment" });
      if (status) this.qrForm = data
      this.loading = false;
    },

    async handleFormSubmit() {
      this.formLoading = true;
      const { status } = await this.$store.dispatch("settings/updateSetting", {
        type: "payment",
        data: {
          ppId: this.qrForm.ppId,
          ppName: this.qrForm.ppName,
          bankName: this.qrForm.bankName,
          bankAccNo: this.qrForm.bankAccNo,
          bankAccName: this.qrForm.bankAccName
        }
      });
      this.formLoading = false;
    }
  },
};
</script>
